import { makeStyles, Theme } from "@material-ui/core";

export default makeStyles((theme: Theme) => {
  return {
    receiptListItem: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      fontSize: 12
    },
    receiptItemHeader: {
      display: "flex",
      justifyContent: "space-between"
    },
    receiptItemDate: {
      color: "#ABABAB",
      marginRight: theme.spacing(2)
    },
    receiptItemAmount: {},
    receiptItemButtonContainer: {
      display: "flex",
      justifyContent: "space-between",
      marginTop: theme.spacing(1)
    },
    productListItem: {},
    productListItemHeader: {
      fontSize: 10,
      color: theme.palette.grey[400],
      marginBottom: theme.spacing(1)
    },
    discountUsage: {
      display: "flex",
      justifyContent: "space-between",
      color: theme.palette.grey[600],
      fontSize: 12
    },
    discountItem: {
      fontSize: 15,
      fontWeight: theme.typography.fontWeightBold,
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      paddingLeft: theme.spacing(1)
    },
    historyPanel: {
      padding: "10px 0px 10px 20px",
      width: "100%"
    },
    eventDetailTableContainer: {
      [theme.breakpoints.down("md")]: {
        justifyContent: "center"
      },
      [theme.breakpoints.up("lg")]: {
        justifyContent: "end"
      }
    },
    eventDetailTable: {
      "& th": {
        color: theme.palette.grey[800]
      },
      [theme.breakpoints.down("md")]: {
        width: "100%",
        "& th": {
          width: "auto"
        }
      },
      [theme.breakpoints.up("lg")]: {
        width: "90%",
        "& th": {
          width: "25%"
        }
      }
    }
  };
});
